import React, { useEffect, useRef, useState } from 'react';
import styles from './style.module.css';

interface AnimatedCardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  hoverEffect?: boolean;
  floatAnimation?: boolean;
}

const AnimatedCard: React.FC<AnimatedCardProps> = ({
  children,
  className = '',
  delay = 0,
  hoverEffect = true,
  floatAnimation = true,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsVisible(true);
            }, delay);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className={`
        ${styles.animatedCard} 
        ${isVisible ? styles.visible : ''} 
        ${hoverEffect ? styles.hoverEffect : ''} 
        ${floatAnimation ? styles.floatAnimation : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default AnimatedCard;